import { render, staticRenderFns } from "./UnreadMessagesWidget.vue?vue&type=template&id=30cbe564&scoped=true"
import script from "./UnreadMessagesWidget.vue?vue&type=script&lang=js"
export * from "./UnreadMessagesWidget.vue?vue&type=script&lang=js"
import style0 from "./UnreadMessagesWidget.vue?vue&type=style&index=0&id=30cbe564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cbe564",
  null
  
)

export default component.exports